/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 *  When the cart is updated by adjusting the quantity or removing a product, it triggers
 * "cart:update" which can be used to check the cart after updates
 *
 */


document.addEventListener('cart:update', function(){
    updateCartAttributeTrigger();
});

document.addEventListener('product:added', function(){
    updateCartAttributeTrigger();
});

document.addEventListener('cart:rerendered', function(){
    console.log('upsells');
    renderUpsells();
});


function updateCartAttributeTrigger() {
    // Get current cart data
    fetch(window.routes.cartUrl + '.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(function (cart) {
        cart.json().then(function (content) {
            const items = content.items;
            let totalBoxesInCart = 0;

            // Get total boxes per line item
            let result = Promise.all(items.map(getLineItemBoxes)).then(data => {
                for (let index = 0; index < data.length; index++) {
                    totalBoxesInCart += data[index];
                }
                updateCartAttribute(totalBoxesInCart);
            });

        })

    })
}
// Get total number of boxes for a line item.
// Get the tag with the boxes: prefix and get the following number and multiply by quantity
function getLineItemBoxes(lineItem) {
    const url = '/products/' + lineItem.handle + '.js';
    return fetch(url)
        .then(data => {
            if (data.status === 200) {
                return data;
            }
        })
        .then(data => data.json())
        .then(data => {
            const boxesTag = data.tags.find(getBoxes);
            if (boxesTag != undefined) {
                const boxes = boxesTag.replace('boxes:','');
                const totalBoxes = boxes * lineItem.quantity;
                return totalBoxes;
            }
        })
}

// Get tag with boxes: prefix
function getBoxes(tag) {
    return tag.includes('boxes:');
}

// Update the cart value
function updateCartAttribute(boxes) {
    fetch('/cart/update' + '.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body:
            JSON.stringify(
                {attributes: {
                        'Total Boxes': boxes
                    }
                })
    }).then(function(response) {

    })
}



let warrartyJSONselect = document.querySelector('[data-warranty-product-json]');

if (warrartyJSONselect) {
    let warrartyJSON = JSON.parse(warrartyJSONselect.innerHTML);
    // Remove warranty items to not promote
    warrartyJSON = warrartyJSON.filter(product => !([8040085356798,8026458358014,8026458849534,8044204785918,8026458259710,8026458620158,8026454655230].includes(product.id)) )
}

function getIndexOfRange(number) {
    if (number == 1) {
        return 0
    } else if (number >=2 && number <=4) {
        return 1
    } else {
        return 2
    }
}

function renderUpsells(){
    fetch(window.routes.cartUrl + '.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(function (cart) {
        cart.json().then(function (content) {
            const items = content.items;

            console.log('~~~~');
            console.log('getWarrantyTags');

            // items == cart items
            // Running getWarrantyTags for each cart item



            let totalFabricSeats = 0;
            let totalLeatherSeats = 0;

            let alltags = Promise.all(items.map(getProductTags)).then(data => {


                let fabricLounges = data.filter((item) => {
                    return (item.tags.includes("Material:Fabric") || item.tags.includes("Material:Suede") || item.tags.includes("Material:Velvet")) && item.tags.includes("Category:Lounge");
                });

                let leatherLounges = data.filter((item) => {
                    return item.tags.includes("Material:Leather") && item.tags.includes("Category:Lounge");
                });

                fabricLounges.forEach(item => {
                    let seatTag = item.tags.find(tag => tag.startsWith('Seating Capacity:'));
                    let capacity = parseInt(seatTag.replace('Seating Capacity:','').replace(' seater',''));
                    totalFabricSeats += (capacity * parseInt(item.qty));
                });

                leatherLounges.forEach(item => {
                    let seatTag = item.tags.find(tag => tag.startsWith('Seating Capacity:'));
                    let capacity = parseInt(seatTag.replace('Seating Capacity:','').replace(' seater',''));
                    totalLeatherSeats += (capacity * parseInt(item.qty));
                });


                const fabricLoungeMap = [
                    warrartyJSON.find(prod => {return prod.tags.includes('Product Category:Lounge') && prod.tags.includes('Material:Fabric') && prod.tags.includes('Seating Capacity:1 seater')}),
                    warrartyJSON.find(prod => {return prod.tags.includes('Product Category:Lounge') && prod.tags.includes('Material:Fabric') && prod.tags.includes('Seating Capacity:4 seater')}),
                    warrartyJSON.find(prod => {return prod.tags.includes('Product Category:Lounge') && prod.tags.includes('Material:Fabric') && prod.tags.includes('Seating capacity:8 seater')})
                ];
                const leatherLoungeMap = [
                    warrartyJSON.find(prod => {return prod.tags.includes('Product Category:Lounge') && prod.tags.includes('Material:Leather') && prod.tags.includes('Seating Capacity:1 seater')}),
                    warrartyJSON.find(prod => {return prod.tags.includes('Product Category:Lounge') && prod.tags.includes('Material:Leather') && prod.tags.includes('Seating Capacity:4 seater')}),
                    warrartyJSON.find(prod => {return prod.tags.includes('Product Category:Lounge') && prod.tags.includes('Material:Leather') && prod.tags.includes('Seating capacity:8 seater')})
                ];

                let fabricLoungeWarranty = [];
                let leatherLoungeWarranty = [];

                const cart_ids = items.map(i => i['id']);

                if (totalFabricSeats > 0) {
                    if (totalFabricSeats <= 8) {
                        let index = getIndexOfRange(totalFabricSeats);
                        fabricLoungeWarranty.push(fabricLoungeMap[index])
                    } else {
                        let seats = Math.floor(totalFabricSeats / 8);
                        let remainder = totalFabricSeats % 8;
                        let i = 0;
                        while (i < seats) {
                            fabricLoungeWarranty.push(fabricLoungeMap[2])
                            i++;
                        }
                        let index = getIndexOfRange(remainder);
                        fabricLoungeWarranty.push(fabricLoungeMap[index])
                    }

                    fabricLoungeWarranty = fabricLoungeWarranty.filter((prod) => {
                        return !(cart_ids.includes(prod.variants[0].id));
                    });
                    fabricLoungeWarranty.forEach(item => {
                        document.querySelector('.guardsman-upsell').innerHTML += buildUpsellProduct(item);
                    });
                }

                if (totalLeatherSeats > 0) {
                    if (totalLeatherSeats <= 8) {
                        let index = getIndexOfRange(totalLeatherSeats);
                        leatherLoungeWarranty.push(leatherLoungeMap[index])
                    } else {
                        let seats = Math.floor(totalLeatherSeats / 8);
                        let remainder = totalLeatherSeats % 8;
                        let i = 0;
                        while (i < seats) {
                            leatherLoungeWarranty.push(leatherLoungeMap[2])
                            i++;
                        }
                        let index = getIndexOfRange(remainder);
                        leatherLoungeWarranty.push(leatherLoungeMap[index])
                    }
                    //console.log(leatherLoungeWarranty, 'leatherLoungeWarranty');
                    leatherLoungeWarranty = leatherLoungeWarranty.filter((prod) => {
                        return !(cart_ids.includes(prod.variants[0].id));
                    });
                    //console.log(leatherLoungeWarranty, 'leatherLoungeWarranty 2');
                    leatherLoungeWarranty.forEach(item => {
                        document.querySelector('.guardsman-upsell').innerHTML += buildUpsellProduct(item);
                    })
                }



            });


            // Logic for warranty suggestions per line item (no couches)
            let result = Promise.all(items.map(getWarrantyTags)).then(data => {

                let flat_data = data.flat();

                //flat_data = flat_data.filter(prod => {return !(prod.title.startsWith('Guardsman ComfortMark II'))});

                const cart_ids = items.map(i => i['id']);
                flat_data = flat_data.filter((prod) => {
                    return !(cart_ids.includes(prod.variants[0].id));
                });

                if(flat_data.length > 0) {
                    document.querySelector('.guardsman-upsell-description').classList.remove('hidden');
                }

                flat_data.forEach(item => {
                    document.querySelector('.guardsman-upsell').innerHTML += buildUpsellProduct(item);
                });
            });

        })

    });
}

function buildUpsellProduct(product){

    //console.log(product,'product');

    let htmlString = `<div style="">
        <div style="display:flex; gap: 15px">
         <img src="${window.getSizedImageUrl(product.featured_image, '80x')}" style="width: 80px;height: auto;"/>
        <div class="warranty-detail">
            <a href="/products/${product.handle}"><strong>${product.title}</strong></a>
            <div class="price">${window.formatMoney(product.price, window.theme.moneyFormat)}</div>  
        </div>
        </div>
        <a class="button button--primary button--small" style="flex:0 0 auto" href="${window.routes.cartAddUrl}?id=${ product.variants[0].id}&quantity=1">Add to cart</a>  
    </div>`;

    return htmlString;

}

function getProductTags(lineItem) {
    const url = '/products/' + lineItem.handle + '.js';
    return fetch(url)
        .then(data => {
            if (data.status === 200) {
                return data;
            }
        })
        .then(data => data.json())
        .then(data => {
            return {tags: data.tags, id: lineItem.id, qty: lineItem.quantity}
        })
}

function getWarrantyTags(lineItem) {

    const url = '/products/' + lineItem.handle + '.js';
    return fetch(url)
        .then(data => {
            if (data.status === 200) {
                return data;
            }
        })
        .then(data => data.json())
        .then(data => {

            //console.log('---------- START ----------');
            return warrartyJSON.filter(warrantyProduct => {


                let warrantyCategoryTag = warrantyProduct.tags.find(tag => {
                    return tag.startsWith('Product Category:')
                });
                let productCategoryTag = data.tags.find(tag => {
                    return tag.startsWith('Category:')
                });

                if (productCategoryTag == 'Category:Lounge') return;  // For now ignore lounge products


                // Always return Timber products if warranty is Timber
                if (data.tags.includes('Material:Timber') && warrantyProduct.title.includes('Timber')) {
                    return true;
                }

                if (warrantyCategoryTag == undefined ||  productCategoryTag == undefined) return false;

                if (warrantyCategoryTag.split('Product Category:').pop()!== productCategoryTag.split('Category:').pop()) return false;

                // If Product is Outdoor and Warranty is Outdoor, always return
                if (productCategoryTag.split('Category:').pop() == 'Outdoor') {
                    return true;
                }

                let filteredTags = data.tags.filter(tag => {
                    return tag.startsWith('Material:') || tag.startsWith('Size:') || tag.startsWith('Seating Capacity:')
                });
                let filteredWarrantyTags = warrantyProduct.tags.filter(tag => {
                    return tag.startsWith('Material:') || tag.startsWith('Size:') || tag.startsWith('Seating Capacity:')
                });

                filteredTags = filteredTags.map(function(item) { return item == 'Material:Suede' || item == 'Material:Velvet' ? 'Material:Fabric' : item; });

                return filteredTags.every(value => filteredWarrantyTags.includes(value));


            });
        })
}